import { supportsLocalStorage } from '../utils/environment';
import { LOCAL_STORAGE_KEY } from '../utils/persistentState';

/* Remove entries, i.e.
    {
        actionType: 'MY_ACTION'
        payload: 'VALUE'
    }
*/
let ENTRIES_TO_REMOVE = [];

/* Remove properties, i.e.
    {
        actionType: 'MY_ACTION', //added 2016-10-21
        property: 'VALUE'
    }
 */

export function setEntriesToRemove(param) {
    ENTRIES_TO_REMOVE = param;
}

export const removeOldEntries = (originalActions) => {
    const actions = { ...originalActions };

    const foundEntriesToRemove = ENTRIES_TO_REMOVE.map((entryToRemove) =>
        Object.keys(actions).find(
            (actionType) =>
                actionType === entryToRemove.actionType && actions[actionType].id === entryToRemove.id
        )
    );

    foundEntriesToRemove.forEach((entry) => {
        if (entry !== undefined) {
            delete actions[entry];
        }
    });

    return actions;
};

// Actions created with a "persistent" flag (set to true) will be stored in local storage.
export const persistentState = () => (next) => (action) => {
    if (action.persistent === true && supportsLocalStorage()) {
        let actions = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');

        let newValue = action.payload;
        // eslint-disable-next-line no-prototype-builtins
        if (actions.hasOwnProperty(action.type)) {
            const original = actions[action.type];

            if (typeof original === 'object' && !Array.isArray(original)) {
                newValue = { ...original, ...action.payload };
            }
        }

        actions[action.type] = newValue;

        // remove outdated stuff from localstorage e.g. after A/B tests
        actions = removeOldEntries(actions);

        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(actions));
    }

    return next(action);
};

export default persistentState;
